module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold.4cdacb8f.ttf";